import * as React from 'react';
import DemoAccountBanner from '../../Teacher/components/shared/demoAccountBanner';

export default props => <DemoAccountBanner {...props} />
